import { GET_INVOICES } from "api/dataProviderTypes";
import { InvoiceRequest } from "api/types";
import { useQuery } from "react-query";
import { getInvoicesByPatient } from "services/invoices";
import { IReturnType } from "types";

/**
 * Liste plate des factures d'un patient. La queryKey inclut le `patientId`
 * pour isoler le cache entre patients.
 */
const useGetInvoices = (patientId?: number | null): IReturnType<InvoiceRequest[]> => {
  const result: IReturnType<InvoiceRequest[]> = useQuery(
    [GET_INVOICES, patientId],
    () => getInvoicesByPatient(patientId as number),
    {
      enabled: patientId != null,
    }
  );

  return result;
};

export default useGetInvoices;
